module.exports = "https://syscdn.233leyuan.com/233xyx-app-new/1616915989142/static/img/redpkg1.fba0d426.png";